import { mxn, fdate } from "@/lib/format";

/** Simulador · Arrendamiento: renta, IVA, residual y CAT (cifras del backend). */
export function ArrendamientoSimKpis({ result }) {
  const a = result.arrendamiento || {};
  const kpis = [
    { l: "Renta (capital + interés)", v: mxn(a.renta_fija), tid: "sim-arr-kpi-renta" },
    { l: "IVA de la renta", v: mxn(a.iva_renta), tid: "sim-arr-kpi-iva" },
    { l: "Total de la renta", v: mxn(Number(a.renta_fija || 0) + Number(a.iva_renta || 0)), tid: "sim-arr-kpi-total" },
    { l: "Valor residual al término", v: mxn(a.valor_residual), tid: "sim-arr-kpi-residual" },
    { l: "Límite opción terminal", v: fdate(a.fecha_limite_opcion_terminal), tid: "sim-arr-kpi-fecha-limite" },
    { l: "Capital a arrendar", v: mxn(a.capital_arrendar), tid: "sim-arr-kpi-capital" },
    { l: "Pago al proveedor", v: mxn(a.monto_proveedor), tid: "sim-arr-kpi-proveedor" },
    { l: "CAT (%)", v: result.cat != null ? `${Number(result.cat).toFixed(2)}%` : "—", tid: "sim-kpi-cat" },
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="sim-arr-kpis">
      {kpis.map((x) => (
        <div key={x.tid} data-testid={x.tid} className="rounded-lg border border-slate-200 bg-white p-3 shadow-sm">
          <p className="text-[11px] uppercase tracking-wide text-slate-500">{x.l}</p>
          <p className="mt-1 font-heading text-lg font-semibold tabular-nums text-slate-900">{x.v}</p>
        </div>
      ))}
    </div>
  );
}
